const api = "https://app.transorientesas.com/api/";
const apiImage = "https://app.transorientesas.com/storage/";
// const api = "http://127.0.0.1:9192/api/";
// const apiImage = "http://127.0.0.1:9192/storage/";
export default api;
export { apiImage };